"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
        xs: "90%",
        sm: 520,
    },
    bgcolor: "white",
    boxShadow: "0px 20px 41px rgba(61, 78, 133, 0.07), 0px 16px 25px rgba(61, 78, 133, 0.0531481), 0px 12px 12px rgba(61, 78, 133, 0.0325), 0px 2px 3.13px rgba(61, 78, 133, 0.02)",
    borderRadius: 2,
    p: { xs: 2, md: 4 },
};
const Modal = ({ open, children, onClose, contentStyle = [], ...props }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Modal, { open: open, onClose: onClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", ...props, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: [
                style,
                ...(Array.isArray(contentStyle) ? contentStyle : [contentStyle]),
            ], children: children }) }));
};
exports.Modal = Modal;
